webpackJsonp([8],{

/***/ 2772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _mfa_controller = __webpack_require__(2773);

var _mfa_controller2 = _interopRequireDefault(_mfa_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var mfa = license.MFA === 'true';
    var enableMultifactorAuthentication = config.EnableMultifactorAuthentication === 'true';
    var enforceMultifactorAuthentication = config.EnforceMultifactorAuthentication === 'true';

    return {
        mfa: mfa,
        enableMultifactorAuthentication: enableMultifactorAuthentication,
        enforceMultifactorAuthentication: enforceMultifactorAuthentication
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_mfa_controller2.default);

/***/ }),

/***/ 2773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _global_actions = __webpack_require__(778);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _setup = __webpack_require__(2774);

var _setup2 = _interopRequireDefault(_setup);

var _confirm = __webpack_require__(2776);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MFAController = function (_React$Component) {
    (0, _inherits3.default)(MFAController, _React$Component);

    function MFAController() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MFAController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MFAController.__proto__ || (0, _getPrototypeOf2.default)(MFAController)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (e) {
            e.preventDefault();
            (0, _global_actions.emitUserLoggedOutEvent)('/login');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MFAController, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.classList.add('sticky');
            document.getElementById('root').classList.add('container-fluid');

            if (!this.props.mfa || !this.props.enableMultifactorAuthentication) {
                this.props.history.push('/');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('sticky');
            document.getElementById('root').classList.remove('container-fluid');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var backButton = void 0;
            if (this.props.enforceMultifactorAuthentication) {
                backButton = _react2.default.createElement(
                    'div',
                    { className: 'signup-header' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none color--link',
                            onClick: this.handleOnClick
                        },
                        _react2.default.createElement('span', { className: 'fa fa-chevron-left' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'web.header.logout',
                            defaultMessage: 'Logout'
                        })
                    )
                );
            } else {
                backButton = _react2.default.createElement(_back_button2.default, null);
            }

            return _react2.default.createElement(
                'div',
                { className: 'inner-wrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'row content' },
                    _react2.default.createElement(
                        'div',
                        null,
                        backButton,
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'signup-team__container' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'mfa.setupTitle',
                                        defaultMessage: 'Multi-factor Authentication Setup'
                                    })
                                ),
                                _react2.default.createElement('img', {
                                    className: 'signup-team-logo',
                                    src: _logo2.default
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { id: 'mfa' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Switch,
                                        null,
                                        _react2.default.createElement(_reactRouterDom.Route, {
                                            path: this.props.match.url + '/setup',
                                            render: function render(props) {
                                                return _react2.default.createElement(_setup2.default, (0, _extends3.default)({
                                                    state: _this2.state,
                                                    updateParent: _this2.updateParent
                                                }, props));
                                            }
                                        }),
                                        _react2.default.createElement(_reactRouterDom.Route, {
                                            path: this.props.match.url + '/confirm',
                                            render: function render(props) {
                                                return _react2.default.createElement(_confirm2.default, (0, _extends3.default)({
                                                    state: _this2.state,
                                                    updateParent: _this2.updateParent
                                                }, props));
                                            }
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MFAController;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MFAController;


MFAController.propTypes = {
    location: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.node,
    mfa: _propTypes2.default.bool.isRequired,
    enableMultifactorAuthentication: _propTypes2.default.bool.isRequired,
    enforceMultifactorAuthentication: _propTypes2.default.bool.isRequired,

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),

/***/ 2774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _setup = __webpack_require__(2775);

var _setup2 = _interopRequireDefault(_setup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    var siteName = config.SiteName;
    var enforceMultifactorAuthentication = config.EnforceMultifactorAuthentication === 'true';

    return {
        siteName: siteName,
        enforceMultifactorAuthentication: enforceMultifactorAuthentication
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_setup2.default);

/***/ }),

/***/ 2775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _user_actions = __webpack_require__(781);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Setup = function (_React$Component) {
    (0, _inherits3.default)(Setup, _React$Component);

    function Setup(props) {
        (0, _classCallCheck3.default)(this, Setup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Setup.__proto__ || (0, _getPrototypeOf2.default)(Setup)).call(this, props));

        _this.submit = function (e) {
            e.preventDefault();
            var code = _this.refs.code.value.replace(/\s/g, '');
            if (!code || code.length === 0) {
                _this.setState({ error: Utils.localizeMessage('mfa.setup.codeError', 'Please enter the code from Google Authenticator.') });
                return;
            }

            _this.setState({ error: null });

            (0, _user_actions.activateMfa)(code, function () {
                _this.props.history.push('/mfa/confirm');
            }, function (err) {
                if (err.id === 'ent.mfa.activate.authenticate.app_error') {
                    _this.setState({ error: Utils.localizeMessage('mfa.setup.badCode', 'Invalid code. If this issue persists, contact your System Administrator.') });
                    return;
                }
                _this.setState({ error: err.message });
            });
        };

        _this.state = { secret: '', qrCode: '' };
        return _this;
    }

    (0, _createClass3.default)(Setup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var user = _user_store2.default.getCurrentUser();
            if (!user || user.mfa_active) {
                this.props.history.push('/');
                return;
            }

            (0, _user_actions.generateMfaSecret)(function (data) {
                return _this2.setState({ secret: data.secret, qrCode: data.qr_code });
            }, function (err) {
                return _this2.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var formClass = 'form-group';
            var errorContent = void 0;
            if (this.state.error) {
                errorContent = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.error
                    )
                );
                formClass += ' has-error';
            }

            var mfaRequired = void 0;
            if (this.props.enforceMultifactorAuthentication) {
                mfaRequired = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'mfa.setup.required',
                        defaultMessage: '<strong>Multi-factor authentication is required on {siteName}.</strong>',
                        values: {
                            siteName: this.props.siteName
                        }
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    {
                        onSubmit: this.submit,
                        className: formClass
                    },
                    mfaRequired,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'mfa.setup.step1',
                            defaultMessage: '<strong>Step 1: </strong>On your phone, download Google Authenticator from <a target=\'_blank\' href=\'https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8\'>iTunes</a> or <a target=\'_blank\' href=\'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en\'>Google Play</a>'
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'mfa.setup.step2',
                            defaultMessage: '<strong>Step 2: </strong>Use Google Authenticator to scan this QR code, or manually type in the secret key'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement('img', {
                                style: style.qrCode,
                                src: 'data:image/png;base64,' + this.state.qrCode
                            })
                        )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'p',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'mfa.setup.secret',
                                defaultMessage: 'Secret: {secret}',
                                values: {
                                    secret: this.state.secret
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'mfa.setup.step3',
                            defaultMessage: '<strong>Step 3: </strong>Enter the code generated by Google Authenticator'
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement('input', {
                            ref: 'code',
                            className: 'form-control',
                            placeholder: Utils.localizeMessage('mfa.setup.code', 'MFA Code'),
                            autoFocus: true
                        })
                    ),
                    errorContent,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: 'btn btn-primary'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'mfa.setup.save',
                            defaultMessage: 'Save'
                        })
                    )
                )
            );
        }
    }]);
    return Setup;
}(_react2.default.Component);

exports.default = Setup;


Setup.propTypes = {
    siteName: _propTypes2.default.string,
    enforceMultifactorAuthentication: _propTypes2.default.bool.isRequired
};

var style = {
    qrCode: { maxHeight: 170 }
};

/***/ }),

/***/ 2776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyCodes = _constants2.default.KeyCodes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Confirm = function (_React$Component) {
    (0, _inherits3.default)(Confirm, _React$Component);

    function Confirm() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Confirm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Confirm.__proto__ || (0, _getPrototypeOf2.default)(Confirm)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (e) {
            e.preventDefault();
            (0, _user_actions.loadMe)().then(function () {
                _this.props.history.push('/');
            });
        }, _this.onKeyPress = function (e) {
            if (_utils2.default.isKeyPressed(e, KeyCodes.ENTER)) {
                _this.submit(e);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Confirm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('keydown', this.onKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('keydown', this.onKeyPress);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    {
                        onSubmit: this.submit,
                        onKeyPress: this.onKeyPress,
                        className: 'form-group'
                    },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'mfa.confirm.complete',
                            defaultMessage: '<strong>Set up complete!</strong>'
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'mfa.confirm.secure',
                            defaultMessage: 'Your account is now secure. Next time you sign in, you will be asked to enter a code from the Google Authenticator app on your phone.'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: 'btn btn-primary'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'mfa.confirm.okay',
                            defaultMessage: 'Okay'
                        })
                    )
                )
            );
        }
    }]);
    return Confirm;
}(_react2.default.Component);

exports.default = Confirm;


Confirm.defaultProps = {};
Confirm.propTypes = {};

/***/ })

});


// WEBPACK FOOTER //
// 8.b7873a549a4781aa0636.js